import {
  registerDecorator,
  ValidationOptions,
  ValidatorConstraint,
  ValidatorConstraintInterface,
  ValidationArguments,
} from 'class-validator';

import { isCuid } from '@paralleldrive/cuid2';

@ValidatorConstraint({ name: 'isCuid', async: false })
class IsCuidValidator implements ValidatorConstraintInterface {
  validate(text: string, _args: ValidationArguments) {
    return isCuid(text);
  }

  defaultMessage(args: ValidationArguments) {
    const { value, property } = args;
    return `${property} ${value} is not a valid CUID!`;
  }
}

export function IsCuid(validationOptions?: ValidationOptions) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [],
      validator: IsCuidValidator,
    });
  };
}
